import { render } from "./VikingGeoJsonMap.vue?vue&type=template&id=39138ef4"
import script from "./VikingGeoJsonMap.vue?vue&type=script&lang=js"
export * from "./VikingGeoJsonMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__